import $ from 'jquery';
$(window).on('scroll', function () {
    if($(window).scrollTop() > 0) {
        $('.header').addClass('header--fixed');
    } else {
        $('.header').removeClass('header--fixed');
    }
})